import _ from 'underscore';
import Backbone from 'backbone';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Constants from 'root/constants';

var Portal = Backbone.Model.extend({
    defaults: {
        account_id           : 0,
        project_id           : 0,
        portal_key           : '',
        portal_name          : '',
        subdomain            : '',
        logo                 : '',
        favicon              : '',
        theme_colour         : '',
        categories           : '',
        powered_by           : false,
        has_feature_requests : true,
        has_roadmap          : true,
        has_announcement     : true,
        approve_portal       : false,
        approve_widget       : false,
        is_active            : false,
        is_public            : false,
        sso_login            : false,
        sso_key              : ''
    },

    getUrl: function(component) {
        var url = 'https://' + this.get('subdomain') + Cache.app.configs.portal_host + '/p/' + this.get('portal_key');


        if (component === 'roadmap') {
            url += '/roadmap';
        } else if (component === 'announcement') {
            url += '/announcement';
        }

        return url;
    },

    isFeedbackVisible: function(feedback_model) {
        if (!feedback_model.get('is_portal_approved')) {
            return false;
        }

        if (feedback_model.get('feedback_type') !== Constants.FEEDBACK_FEATURE_REQUEST) {
            return false;
        }

        if (!this.get('has_feature_requests') && !this.get('has_roadmap')) {
            return false;
        }

        return true;
    },

    getTranslation: function(key, has_link) {
        var custom_translation = this.get('translation');

        var default_translation = {
            submit_idea_button: 'Submit Idea',
            new_idea_button: 'New Idea',
            new_idea_heading: 'Tell us about your idea',
            new_idea_desc: 'Please check if a request already exists by using the search function! If you find one, add your vote there instead!',
            new_idea_title_placeholder: 'Give your idea a title',
            new_idea_summary_placeholder: 'Description: add more details to help us build better products for you to use!',
            new_idea_thankyou: 'Thank you for submitting your idea!\nOnce your idea is approved, it will appear in the portal.',
            private_access: 'Private\nOnly logged in users can access the ideas portal.'
        };

        _.each(default_translation, function(val, key) {
            if (custom_translation && custom_translation[key]) {
                default_translation[key] = custom_translation[key];
            }
        });

        if (has_link) {
            return Util.htmlEntitiesWithA(default_translation[key], true);
        } else {
            return Util.htmlEntities(default_translation[key]);
        }
    }
});

export default Portal;